import React from 'react';
import { Microscope, Activity, ShieldCheck } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const DiagnosticsPage = () => {
  const config = {
    badge: "Advanced Imaging",
    headline: "CT Scan, Ultrasound",
    headlineItalic: "& More.",
    subtext: "Comprehensive in-clinic advanced imaging delivering cross-sectional, soft tissue, and cardiac detail that standard radiography cannot match.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Advanced Veterinary Imaging at Dr. Suresh Pet Care — CT, Ultrasound, 2D Echo",
    stats: [
      { value: 5000, suffix: '+', label: 'Imaging Studies' },
      { value: 48, suffix: 'hr', label: 'Max Report Time' },
      { value: 24, suffix: '/7', label: 'Emergency Imaging' },
      { value: 99, suffix: '%', label: 'Image Quality' },
    ],
    services: [
      {
        title: "CT Scanning",
        icon: <Microscope size={28} />,
        desc: "Multi-slice CT imaging for advanced evaluation of complex skull, spinal, thoracic, and abdominal pathology.",
        specs: ["Brain & Skull CT", "Thoracic CT", "Musculoskeletal CT", "Contrast Studies"],
        color: "from-blue-500/10 to-primary/10"
      },
      {
        title: "Ultrasound (USG)",
        icon: <Activity size={28} />,
        desc: "Real-time soft tissue ultrasound for abdominal organs, masses, pregnancy, and guided biopsy procedures.",
        specs: ["Abdominal USG", "Guided Biopsy", "Pregnancy Scan", "Bladder Assessment"],
        color: "from-primary/10 to-teal-500/10"
      },
      {
        title: "2D Echocardiography",
        icon: <ShieldCheck size={28} />,
        desc: "Advanced cardiac ultrasound assessing chamber dimensions, wall motion, valve competence, and pericardial effusion.",
        specs: ["Cardiac Chambers", "Valve Function", "Pericardial Effusion", "Cardiac Output"],
        color: "from-purple-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Imaging",
    sectionItalic: "Modalities.",
    warningTitle: "When Advanced Imaging",
    warningItalic: "Is Essential.",
    warningText: "Advanced imaging finds what other tests miss — enabling surgical planning, biopsy guidance, and definitive diagnosis of complex conditions.",
    warnings: [
      { name: "Mass Staging", desc: "CT and ultrasound determine tumor extent, invasiveness, and surgical resectability.", icon: "🔬" },
      { name: "Soft Tissue Injury", desc: "Ligaments, organs, and soft structures are invisible on X-ray — ultrasound finds them.", icon: "🩺" },
      { name: "Cardiac Disease", desc: "2D Echo is the definitive tool for diagnosing and staging heart disease in pets.", icon: "❤️" },
      { name: "Surgical Planning", desc: "CT provides 3D reconstruction for complex surgical planning and approach mapping.", icon: "🗺️" },
    ],
    ctaBadge: "Imaging Excellence",
    ctaTitle: "The Imaging",
    ctaItalic: "Expertise.",
    ctaText: "Our advanced imaging suite combines CT, ultrasound, and echocardiography under one roof, enabling comprehensive diagnostic workups in a single visit.",
    ctaBtn: "Book Advanced Imaging",
    seoText: "Advanced veterinary imaging in Hyderabad. CT scan, ultrasound, and 2D Echo for pets at Dr. Suresh Pet Care. Cutting-edge diagnostic imaging services.",
    glowColor: "blue-500"
  };

  return (
    <>
      <SEO 
        title="Advanced Veterinary Diagnostics in Hyderabad | CT & Ultrasound"
        description="Expert pet imaging diagnostics in Vanasthalipuram. We offer CT scans, ultrasound, and 2D Echo for complete clinical assessments of your pets."
        canonical="/diagnostics"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default DiagnosticsPage;
